import { render, staticRenderFns } from "./RelatorioCard.vue?vue&type=template&id=63a0d6ae&scoped=true&"
import script from "./RelatorioCard.vue?vue&type=script&lang=js&"
export * from "./RelatorioCard.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioCard.vue?vue&type=style&index=0&id=63a0d6ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a0d6ae",
  null
  
)

export default component.exports